import CircleButtonSmall from './CircleButtonSmall';

export default CircleButtonSmall;
